import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseUpdateDto } from '../../base/baseUpdate.dto'

@ArgsType()
export class UpdateMessagePostDto extends BaseUpdateDto<UpdateMessagePostDto> {
  @Field(t => Int)
  state!: number
}
